export const BLOOD_TYPES = ["A형","B형","O형","AB형"];
export const MBTI_LIST = ["INTJ","INTP","ENTJ","ENTP","INFJ","INFP","ENFJ","ENFP","ISTJ","ISFJ","ESTJ","ESFJ","ISTP","ISFP","ESTP","ESFP"];
export const ZODIAC = ["양자리 (3.21~4.19)","황소자리 (4.20~5.20)","쌍둥이자리 (5.21~6.21)","게자리 (6.22~7.22)","사자자리 (7.23~8.22)","처녀자리 (8.23~9.22)","천칭자리 (9.23~10.23)","전갈자리 (10.24~11.21)","사수자리 (11.22~12.21)","염소자리 (12.22~1.19)","물병자리 (1.20~2.18)","물고기자리 (2.19~3.20)"];
export const ZODIAC_EN = ["Aries (3.21~4.19)","Taurus (4.20~5.20)","Gemini (5.21~6.21)","Cancer (6.22~7.22)","Leo (7.23~8.22)","Virgo (8.23~9.22)","Libra (9.23~10.23)","Scorpio (10.24~11.21)","Sagittarius (11.22~12.21)","Capricorn (12.22~1.19)","Aquarius (1.20~2.18)","Pisces (2.19~3.20)"];

export const PROGRESS_STAGES = [
  { at: 0,  icon: "🔍", label: "개인 성향 분석 중..." },
  { at: 18, icon: "🌠", label: "여행지 정보 수집 중..." },
  { at: 35, icon: "🗓️", label: "날짜별 일정 구성 중..." },
  { at: 52, icon: "☀️", label: "날씨 정보 분석 중..." },
  { at: 68, icon: "🍽️", label: "맛집 & 식당 추천 중..." },
  { at: 82, icon: "🚗", label: "이동 경로 최적화 중..." },
  { at: 93, icon: "✨", label: "최종 일정 마무리 중..." },
];

export const BADGE_DEFS = [
  { id:"first_plan",    icon:"🗺️",  name:"첫 탐험가",     desc:"첫 여행 일정 생성",          color:"#7BB8F0" },
  { id:"reviewer",      icon:"✍️",  name:"여행 작가",     desc:"후기 1개 작성",               color:"#F0A07A" },
  { id:"reviewer3",     icon:"📖",  name:"베테랑 리뷰어", desc:"후기 3개 작성",               color:"#E8935A" },
  { id:"five_star",     icon:"⭐",  name:"별점 만점",     desc:"만점 후기 작성",              color:"#F5C842" },
  { id:"globetrotter",  icon:"🌏",  name:"글로벌 여행자", desc:"3개 이상 다른 여행지 방문",   color:"#8DD9C0" },
  { id:"foodie",        icon:"🍜",  name:"푸드 헌터",     desc:"음식 항목 별점 5점",          color:"#FF9F7A" },
  { id:"photographer",  icon:"📸",  name:"포토그래퍼",    desc:"사진 5장 첨부",               color:"#C5A56A" },
  { id:"liked",         icon:"👍",  name:"인기 여행자",   desc:"좋아요 5개 이상 획득",        color:"#B5809A" },
  { id:"early_bird",    icon:"🌅",  name:"얼리버드",      desc:"오전 일정 3회 이상 포함",     color:"#90C9B4" },
  { id:"planner10",     icon:"🏅",  name:"플래너 10",     desc:"일정 10회 생성",              color:"#E8B96A" },
];

export const DEST_EMOJIS = { "제주":"🌊", "서울":"🏙️", "부산":"🌅", "경주":"🏛️", "강원":"⛰️", "전주":"🏘️", "여수":"⛵", "속초":"🎣", "강릉":"🌊", "수원":"🏯" };

export const GYENAM_CITIES = ["경상남도","경남","창원","진주","통영","거제","사천","밀양","함양","거창","합천","남해","하동","산청","의령","함안","창녕","고성","양산"];
